<template>
  <v-layout class="component-actor-panel">
    <v-container fluid>
      <AdBreadcrumbs :items="breadcrumbs" />
      <PanelLoading :loading="$store.getters['scenario/loadingActors']" />
      <v-row v-if="!$store.getters['scenario/loadingActors']">
        <v-col>
          <v-card>
            <AdCardTitle prependicon="mdi-account-cog">
              {{ $t('actors-in-all-scenarios') }}
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                class="mr-2"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                solo
                dense
                clearable
              ></v-text-field>

              <ActorFormDialog ref="actorFormDialog"/>
            </AdCardTitle>

            <v-card-text class="pt-4">
              <v-data-table
                :headers="headersFiltered"
                :items="items"
                :search="search"
                item-key="id"
                :no-data-text="$t('no-actors')"
                single-select
                :custom-filter="searchFilter"
              >

                <template v-slot:[`item.type`]="{ item }">
                  <v-icon v-if="item.type === 'organization'">mdi-hospital-building</v-icon>
                  <v-icon v-if="item.type === 'person'">mdi-doctor</v-icon>
                  <v-icon v-if="item.type === 'device'">mdi-monitor</v-icon>
                </template>

                <template v-slot:[`item.name`]="{ item }">
                  {{ $filters.getMatchingTranslation({ value: item.name }) }}
                </template>

                <template v-slot:[`item.desc`]="{ item }">
                  <div v-html="$filters.getMatchingTranslation({ value: item.desc })"></div>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <div v-if="userIsEditor" class="text-no-wrap">
                    <AdSpeedDial
                      :open-on-hover="true"
                      direction="left"
                    >
                        <AdButton
                          v-if="userIsDBA"
                          type="erase"
                          list
                          @click="deleteActor(item)"
                        />
                        <AdButton
                          type="edit"
                          list
                          @click="editActor(item)"
                        />
                    </AdSpeedDial>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>

</template>

<script>
import ActorFormDialog from '@/components/Scenario/ActorFormDialog'

export default {
  name: 'ActorPanel',
  components: {
    ActorFormDialog
  },
  data () {
    return {

      search: null
    }
  },
  computed: {
    breadcrumbs () {
      const breadcrumbs = [
        {
          text: this.$filters.getMatchingTranslation({ value: this.projectInFocus?.name }),
          to: { name: 'project-overview' },
          show: ['actors']
        },
        {
          text: this.$t('scenarios'),
          disabled: true,
          show: ['actors']
        },
        {
          exact: true,
          text: this.$t('actors'),
          to: { name: 'actors' },
          show: ['actors']
        }
      ]
      return breadcrumbs.filter((breadcrumb) => breadcrumb.show.includes(this.$route.name))
    },
    headers () {
      return [
        { text: this.$t('type'), value: 'type', sortable: true, width: '100px' },
        { text: this.$t('name'), value: 'name', sortable: true, width: '25%' },
        { text: this.$t('description'), value: 'desc', sortable: false, width: '65%' },
        { text: this.$t('actions'), value: 'actions', condition: 'userIsEditor', width: '100px' }
      ]
    },
    headersFiltered () {
      // Function that conditionally checks if a column should be shown
      // Without the function the conditional column (like actions) reserves space in the table, in the situation that it is not needed
      return this.headers.filter((header) => !Object.prototype.hasOwnProperty.call(header, 'condition') || this?.[header.condition])
    },
    items () {
      return this.$store.getters['scenario/actors']
    }
  },
  mounted () {
    if (!this.$store.state.scenario.loaded.actors) {
      this.loadActorList()
    }
  },
  methods: {
    async loadActorList () {
      return this.$store.dispatch('scenario/setActors')
        .catch((error) => {
          const errorMessage = error?.response?.data?.description || error?.response?.statusText || 'Error'
          this.$oops(errorMessage)
        })
    },
    async editActor (item) {
      this.$refs.actorFormDialog.open(item)
    },
    async deleteActor (item) {
      const message = this.$t('remove') + ' ' + this.$filters.getMatchingTranslation({ value: item.name }) + '?'
      const agree = await this.$confirm(message + ' ' + this.$t('are-you-sure-this-action-cannot-be-undone'))
      if (agree) {
        return this.$store.dispatch('scenario/deleteActor', item)
          .then(() => {
            this.$notify(this.$t('submission-update-success-label'), 'success')
          })
          .catch((error) => {
            const errorMessage = error?.response?.data?.description || error?.response?.statusText || 'Error'
            this.$alert(errorMessage)
          })
      }
    },
    searchFilter (value, search, item) {
      const name = this.$filters.getMatchingTranslation({ value: item.name })?.toLowerCase()
      const query = search.toLowerCase()
      return name?.includes(query)
    }
  }
}
</script>

<style lang="scss" scoped>
.component-actor-panel {
  table {
    tr {
      td {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        &:not(.v-data-table__mobile-row) {
          max-width: 0;
        }
      }
    }
  }
}
</style>
